export default __webpack_public_path__ + "static/media/vertical_darktolight.49fa0e50.png";